export const DESTINATION_TYPE_MULTICOUNTRY = 'multicountry';
export const DESTINATION_TYPE_COUNTRY = 'country';
export const DESTINATION_TYPE_DESTINATION = 'destination';
export const DESTINATION_TYPE_CITY = 'city';
export const DESTINATION_TYPE_HOTEL = 'hotel';
export const DESTINATION_TYPE_CONTINENT = 'continent';
export const DESTINATION_TYPE_HOLIDAYHOME = 'holidayHome';
export const PROMO_LINK_ITEM = 'promoLinkItem';